import style from '../NotificationsModal.module.scss'
import { Modal } from 'react-bootstrap'
import React from 'react'

interface NotificationsHeaderProps {
    handleFilterClose: () => void
}

export const NotificationsHeader = (props: NotificationsHeaderProps) => {
    const { handleFilterClose } = props

    return <Modal.Header
        onClick={handleFilterClose}
        className={style.header}
    >
        <Modal.Title>
            Notifications &nbsp;
        </Modal.Title>
    </Modal.Header>
}